import { render, staticRenderFns } from "./FormPlanMembresia.vue?vue&type=template&id=6a31a544&scoped=true"
import script from "./FormPlanMembresia.vue?vue&type=script&lang=js"
export * from "./FormPlanMembresia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a31a544",
  null
  
)

export default component.exports